import { deserialize } from 'cerialize'

export class RecommendationModel {
	@deserialize public id: number = null
	@deserialize public product_id?: number
	@deserialize public products?: {
		id: number
		name: string
	}[]
	@deserialize public name = ''
	@deserialize public okved_codes: string[] = []
	@deserialize public partner_type: 'new' | 'active'
	@deserialize public base_container: boolean

	public get product_names(): string | undefined {
		return (
			this?.products &&
			this.products.map((i: { id: number; name: string }): string => i.name || '').join(', ')
		)
	}

	public get okved_codes_string(): string | undefined {
		return this?.okved_codes?.join(', ')
	}

	public get partner_type_string(): string | undefined {
		return this?.partner_type === 'new' ? 'Новый' : 'Действующий'
	}

	public constructor(data?) {
		if (data) {
			Object.keys(data).forEach((key: string): void => {
				this[key] = data[key]
			})
		}
	}
}
